/* Compact visual selectors around the original Shopify and TEPO controls.
   No variant, property, quantity, validation or purchase logic is replaced. */
(() => {
  const page = document.querySelector('#MainContent [id^="ProductSection-"]');
  if (!page) return;
  const variants = page.querySelector('variant-radios');
  let steps = [], queued = false;
  let woodSamples = {};
  try { woodSamples = JSON.parse(document.getElementById('ad-wood-samples')?.textContent || '{}'); } catch (_) {}
  const woodKey = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
  function woodThumbnails(field) {
    const name = field.querySelector('legend')?.textContent || '';
    if (!/cubierta|madera|especie/i.test(name)) return;
    let count = 0;
    field.querySelectorAll('input[type="radio"]').forEach(input => {
      const src = woodSamples[woodKey(input.value)];
      const label = input.id && field.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (!src || !label?.querySelector('.text')) return;
      count++;
      label.classList.add('ad-wood-option');
      if (label.querySelector('.ad-wood-sample')) return;
      const image = document.createElement('img'); image.className = 'ad-wood-sample';
      image.src = src; image.alt = ''; image.width = 64; image.height = 64; image.loading = 'lazy'; image.decoding = 'async';
      image.addEventListener('error', () => { image.hidden = true; });
      label.prepend(image);
    });
    if (!count) return;
    field.classList.add('ad-wood-choices');
    if (!field.querySelector('.ad-wood-note')) {
      const note = document.createElement('p'); note.className = 'ad-wood-note';
      note.textContent = 'Muestras en terminación natural. La veta y el tono varían en cada pieza.';
      field.querySelector('.ad-choice-next').before(note);
    }
  }

  // Request crisp CDN versions without changing the original sample or app values.
  function sharpOptionImages(field) {
    field.querySelectorAll('.pattern').forEach(pattern => {
      const source = pattern.style.backgroundImage;
      if (source.includes('/cdn/shop/files/')) {
        const sharp = source.replace(/_120x(?=\.)/g, '_240x');
        if (sharp !== source) pattern.style.backgroundImage = sharp;
      }
    });
    const images = [...field.querySelectorAll('.tcustomizer__image-content')];
    if (images.length) field.classList.add('ad-visual-choice');
    images.forEach(image => {
      if (image.dataset.adSharpFailed) return;
      let url;
      try { url = new URL(image.getAttribute('src'), location.href); } catch (_) { return; }
      if (url.hostname !== 'cdn.tepo.app' || !url.searchParams.has('w')) return;
      const sized = width => { const next = new URL(url); next.searchParams.set('w', String(width)); return next.href; };
      const src = sized(320), srcset = `${sized(160)} 1x, ${src} 2x, ${sized(480)} 3x`;
      if (image.getAttribute('srcset') !== srcset) {
        image.setAttribute('loading', 'lazy'); image.setAttribute('decoding', 'async');
        image.setAttribute('srcset', srcset); image.setAttribute('src', src);
        image.width = 64; image.height = 64;
        if (!image.dataset.adSharpFallback) {
          image.dataset.adSharpFallback = 'true';
          const original = image.getAttribute('src');
          image.addEventListener('error', () => {
            if (image.dataset.adSharpFailed) return;
            image.dataset.adSharpFailed = 'true'; image.removeAttribute('srcset');
            const fallback = new URL(original); fallback.searchParams.set('w', '100'); image.src = fallback.href;
          });
        }
      }
    });
  }

  const clean = text => (text || '').replace(/\*/g, '').replace(/:\s*$/, '').trim();
  const setText = (node, value) => { if (node.textContent !== value) node.textContent = value; };
  function selected(field) {
    const checked = [...field.querySelectorAll('input:checked')];
    if (checked.length) {
      return checked.map(input => {
        const label = input.id && field.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        return clean(label?.querySelector('.text')?.firstChild?.textContent || input.value);
      }).join(', ');
    }
    if (field.querySelector('input[type="radio"],input[type="checkbox"]')) return '';
    const control = field.querySelector('select,textarea,input:not([type="hidden"]):not([type="number"]):not([type="radio"]):not([type="checkbox"])');
    return control?.tagName === 'SELECT' ? clean(control.selectedOptions[0]?.textContent) : clean(control?.value);
  }
  function close(field) {
    if (field.classList.contains('ad-grid')) return;
    field.classList.remove('is-open');
    const toggle = field.querySelector('.ad-choice-toggle');
    if (field.classList.contains('ad-gallery-color')) toggle?.removeAttribute('aria-expanded');
    else toggle?.setAttribute('aria-expanded', 'false');
  }
  function selectionPreview(field) {
    // Mark handle and tone steps first: the grid layout also uses these classes.
    const kind = field.querySelector('.ad-choice-title')?.textContent || '';
    if (/tiradores/i.test(kind)) field.classList.add('ad-handle-choices');
    else if (/^tonalidad de la cubierta$/i.test(kind)) field.classList.add('ad-tone-choices');
    if (!field.classList.contains('ad-dropdown')) return;
    const preview = field.querySelector('.ad-choice-preview');
    const input = field.querySelector('input:checked');
    let label = input?.id && field.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    const title = field.querySelector('.ad-choice-title')?.textContent || '';
    const handles = /tiradores/i.test(title);
    const tone = /^tonalidad de la cubierta$/i.test(title);
    let example = null;
    if (handles || tone) {
      field.classList.add(handles ? 'ad-handle-choices' : 'ad-tone-choices');
      if (!input) {
        const choices = [...field.querySelectorAll('input[type="radio"]:not(:disabled)')].filter(candidate => {
          const item = field.querySelector(`label[for="${CSS.escape(candidate.id)}"]`);
          return item?.style.display !== 'none' && !!item?.querySelector('.tcustomizer__image-content');
        });
        example = tone ? choices.find(candidate => /^natural$/i.test(candidate.value.trim())) || choices.find(candidate => !/mismo color/i.test(candidate.value)) || choices[0] : choices[0];
        if (example) label = field.querySelector(`label[for="${CSS.escape(example.id)}"]`);
      }
    }
    const image = label?.querySelector('.ad-wood-sample,.tcustomizer__image-content');
    const pattern = label?.querySelector('.pattern');
    const src = image?.getAttribute('src') || '';
    const background = pattern?.style.backgroundImage || '';
    const color = pattern?.style.backgroundColor || '';
    const key = `${src}|${background}|${color}|${!!example}`;
    if (preview.dataset.key === key) return;
    preview.dataset.key = key;
    preview.title = example ? `Vista previa: ${example.value}. ${handles ? 'Elige tu tirador.' : 'Elige la tonalidad de la cubierta.'}` : '';
    preview.replaceChildren();
    preview.style.backgroundImage = background;
    preview.style.backgroundColor = color;
    preview.hidden = !(src || background || color);
    if (src) {
      const thumb = document.createElement('img');
      thumb.src = src; thumb.alt = ''; thumb.width = 32; thumb.height = 32;
      if (image.getAttribute('srcset')) thumb.setAttribute('srcset', image.getAttribute('srcset'));
      preview.append(thumb);
    }
  }
  function open(field, scroll = false) {
    if (!field?.classList.contains('ad-choice')) return;
    steps.filter(step => step !== field).forEach(close);
    if (field.classList.contains('ad-gallery-color')) { showGalleryColor(); return; }
    if (field.classList.contains('ad-grid')) {
      if (scroll) {
        const offset = (parseFloat(document.documentElement.style.getPropertyValue('--ad-sticky-height')) || 0) + 16;
        window.scrollTo({ top: Math.max(0, field.getBoundingClientRect().top + window.scrollY - offset), behavior: 'auto' });
      }
      return;
    }
    field.classList.add('is-open');
    field.querySelector('.ad-choice-toggle').setAttribute('aria-expanded', 'true');
    if (scroll) {
      const offset = (parseFloat(document.documentElement.style.getPropertyValue('--ad-sticky-height')) || 0) + 16;
      window.scrollTo({ top: Math.max(0, field.getBoundingClientRect().top + window.scrollY - offset), behavior: 'auto' });
    }
  }
  function enhance(field, index) {
    const app = field.matches('.tcustomizer-field');
    const heading = field.querySelector(app ? '.tcustomizer-field__heading' : 'legend');
    if (!heading) return;
    if (!field.querySelector(':scope > .ad-choice-toggle')) {
      const name = app ? clean(heading.textContent) : clean(heading.childNodes[0]?.textContent);
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'ad-choice-toggle';
      const number = document.createElement('span'); number.className = 'ad-choice-number'; number.setAttribute('aria-hidden', 'true');
      const copy = document.createElement('span'); copy.className = 'ad-choice-copy';
      const title = document.createElement('span'); title.className = 'ad-choice-title'; title.textContent = /^cubierta$/i.test(name) ? 'Tipo de madera de la cubierta' : /^terminaci[oó]n(?: de la)? cubierta$/i.test(name) ? 'Tonalidad de la cubierta' : /tiradores/i.test(name) ? 'Tiradores' : /especificación adicional/i.test(name) ? 'Indicaciones adicionales' : name;
      const summary = document.createElement('span'); summary.className = 'ad-choice-value';
      const icon = document.createElement('span'); icon.className = 'ad-choice-icon'; icon.textContent = '⌄'; icon.setAttribute('aria-hidden', 'true');
      const preview = document.createElement('span'); preview.className = 'ad-choice-preview';
      preview.hidden = true; preview.setAttribute('aria-hidden', 'true');
      copy.append(title, summary); button.append(number, preview, copy, icon);
      heading.after(button); field.classList.add('ad-choice');
      if (!field.id) field.id = `ad-choice-${page.id}-${index}`;
      button.setAttribute('aria-controls', field.id);
      // Keep the original inputs; present each choice as a closed visual selector.
      field.classList.toggle('ad-dropdown', !app || !!field.querySelector('input[type="radio"],select'));
      icon.textContent = field.classList.contains('ad-dropdown') ? '⌄' : '+';
      close(field);
      // Options stay visible as tiles: closed lists hide the alternatives (Baymard). The color
      // keeps its own swatches next to the photo; free-text fields stay collapsible.
      if (app ? !!field.querySelector('input[type="radio"]') : !/^colou?r(?:\s|$)/i.test(name)) {
        field.classList.add('ad-grid', 'is-open'); field.classList.remove('ad-dropdown');
        button.tabIndex = -1; button.removeAttribute('aria-controls'); button.removeAttribute('aria-expanded');
      }
      button.addEventListener('click', () => {
        if (field.classList.contains('ad-grid')) return;
        if (field.classList.contains('is-open')) close(field);
        else open(field);
      });
      const next = document.createElement('button'); next.type = 'button'; next.className = 'ad-choice-next';
      next.textContent = 'Continuar →';
      next.addEventListener('click', () => {
        const mandatory = !app || !!field.querySelector('.tcustomizer-asterisk');
        if (mandatory && !selected(field)) {
          const value = field.querySelector('.ad-choice-value'); setText(value, 'Elige una opción para continuar'); value.setAttribute('role', 'alert'); return;
        }
        const target = steps[steps.indexOf(field) + 1];
        if (target) { open(target, true); target.querySelector('.ad-choice-toggle').focus({ preventScroll: true }); }
        else {
          const buy = page.querySelector('#tcustomizer-add') || page.querySelector('button[name="add"]');
          buy?.scrollIntoView({ block: 'center', behavior: 'auto' }); buy?.focus({ preventScroll: true });
        }
      });
      field.append(next);
      if (!app) field.querySelectorAll('label .pattern').forEach(pattern => {
        const label = pattern.closest('label'); const input = document.getElementById(label.htmlFor);
        if (!input || label.querySelector('.ad-swatch-name')) return;
        const name = document.createElement('span'); name.className = 'ad-swatch-name'; name.textContent = input.value; label.append(name);
      });
    }
    setText(field.querySelector('.ad-choice-number'), String(index + 1).padStart(2, '0'));
    const value = selected(field), optional = app && !field.querySelector('.tcustomizer-asterisk');
    setText(field.querySelector('.ad-choice-value'), value || (field.classList.contains('ad-grid') ? (optional ? 'Opcional' : 'Elige una opción') : /tiradores/i.test(field.querySelector('.ad-choice-title').textContent) ? 'Vista previa · Elige tu tirador' : /^tonalidad de la cubierta$/i.test(field.querySelector('.ad-choice-title').textContent) ? 'Vista previa · Elige la tonalidad' : optional ? 'Opcional' : 'Obligatorio · Elige tu preferencia'));
    field.classList.toggle('has-selection', !!value);
  }
  function compareAfterOptions() {
    const compare = page.querySelector('.productView-compareColor.style-1');
    const anchor = page.querySelector('.productView-form .tcustomizer-widget') || variants;
    if (!compare || !anchor || anchor.nextElementSibling === compare) return;
    const source = compare.parentElement;
    const sourceSlot = source.matches('.productView-perks') ? source.closest('.productView-moreItem') : null;
    // Move the original control, preserving its delegated popup handler.
    anchor.after(compare);
    compare.classList.add('ad-compare-last');
    if (source.matches('.productView-perks') && !source.children.length) {
      source.hidden = true;
      if (sourceSlot?.children.length === 1 && sourceSlot.firstElementChild === source) sourceSlot.hidden = true;
    }
  }
  function init() {
    queued = false;
    steps = [...(variants?.querySelectorAll('fieldset') || []), ...page.querySelectorAll('.productView-form .tcustomizer-field')].filter(field => field.getClientRects().length);
    steps.forEach(enhance);
    steps.filter(field => field.matches('fieldset')).forEach(woodThumbnails);
    steps.forEach(sharpOptionImages);
    steps.forEach(selectionPreview);
    galleryColors();
    compareAfterOptions();
    selectionSummary();
    if (variants && steps.length && !variants.querySelector('.ad-personalize-intro')) {
      const intro = document.createElement('div'); intro.className = 'ad-personalize-intro';
      const title = document.createElement('h2'); title.textContent = 'Diseña tu mueble';
      const copy = document.createElement('p'); copy.textContent = 'Elige cada detalle. Puedes volver a editarlo cuando quieras.';
      intro.append(title, copy); variants.prepend(intro);
    }
    steps.forEach(field => {
      const hasError = field.classList.contains('arca-option-missing') || !!field.querySelector('.tcustomizer-error:not(:empty)');
      if (hasError && !field.dataset.adErrorOpened) { field.dataset.adErrorOpened = 'true'; open(field); }
      if (!hasError) delete field.dataset.adErrorOpened;
    });
  }
  // «Tu selección»: resumen de lo elegido junto al botón de compra, con un enlace para
  // guardarse el diseño en WhatsApp (compartir sin número: no cuenta como contacto con Arca).
  function summaryLabel(field) {
    const title = clean(field.querySelector('.ad-choice-title')?.textContent);
    if (/^colou?r/i.test(title)) return 'Color';
    if (/madera de la cubierta/i.test(title)) return 'Madera de la cubierta';
    if (/^tonalidad/i.test(title)) return 'Tonalidad';
    return title;
  }
  function selectionSummary() {
    const form = page.querySelector('.productView-form');
    const anchor = form?.querySelector('.productView-subtotal');
    if (!form || !anchor || !steps.length) return;
    const rows = [];
    steps.forEach(field => {
      const value = selected(field).replace(/\s+/g, ' ').trim();
      const optional = field.matches('.tcustomizer-field') && !field.querySelector('.tcustomizer-asterisk');
      if (optional && !value) return;
      rows.push([summaryLabel(field), value]);
    });
    if (!rows.length) return;
    const title = clean(page.querySelector('.productView-title')?.textContent) || document.title;
    const variantId = form.querySelector('[name="id"]')?.value || new URLSearchParams(location.search).get('variant') || '';
    const url = location.origin + location.pathname + (variantId ? '?variant=' + variantId : '');
    const key = JSON.stringify([rows, url]);
    let box = form.querySelector('.ad-summary');
    if (box && box.dataset.key === key) return;
    if (!box) {
      box = document.createElement('section'); box.className = 'ad-summary';
      box.setAttribute('aria-label', 'Resumen de tu selección');
      anchor.before(box);
    }
    box.dataset.key = key;
    const heading = document.createElement('h3'); heading.textContent = 'Tu selección';
    const list = document.createElement('dl');
    rows.forEach(([label, value]) => {
      const dt = document.createElement('dt'); dt.textContent = label;
      const dd = document.createElement('dd'); dd.textContent = value || 'Falta elegir';
      if (!value) dd.className = 'is-missing';
      list.append(dt, dd);
    });
    const text = `Mi diseño Arca: ${title}\n` + rows.filter(([, value]) => value).map(([label, value]) => `• ${label}: ${value}`).join('\n') + `\n${url}`;
    const share = document.createElement('a'); share.className = 'ad-summary-share';
    share.href = 'https://wa.me/?text=' + encodeURIComponent(text);
    share.target = '_blank'; share.rel = 'noopener';
    share.textContent = 'Guardar mi diseño en WhatsApp';
    box.replaceChildren(heading, list, share);
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(init); } }
  let colorSource = null;
  function showGalleryColor() {
    const gallery = page.querySelector('.productView-image-wrapper') || page.querySelector('.productView-images-wrapper');
    const selectedButton = page.querySelector('.ad-photo-color[aria-pressed="true"]');
    if (!gallery || !selectedButton) return;
    requestAnimationFrame(() => {
      selectedButton.focus({ preventScroll: true });
      const offset = (parseFloat(document.documentElement.style.getPropertyValue('--ad-sticky-height')) || 0) + 16;
      window.scrollTo({ top: Math.max(0, gallery.getBoundingClientRect().top + window.scrollY - offset), behavior: window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth' });
    });
  }
  function galleryColors() {
    const field = steps.find(step => variants?.contains(step) && /^colou?r(?:\s|$)/i.test(step.querySelector('.ad-choice-title')?.textContent || ''));
    const gallery = page.querySelector('.productView-image-wrapper') || page.querySelector('.productView-images-wrapper');
    if (!field || !gallery) return;
    colorSource = field;
    field.classList.add('ad-gallery-color');
    field.querySelector('.ad-choice-toggle').removeAttribute('aria-expanded');
    field.querySelector('.ad-choice-toggle').removeAttribute('aria-controls');
    setText(field.querySelector('.ad-choice-title'), 'Color · ver en la foto');
    setText(field.querySelector('.ad-choice-icon'), '↑');
    let panel = page.querySelector('.ad-photo-colors');
    if (!panel) {
      panel = document.createElement('section'); panel.className = 'ad-photo-colors';
      panel.setAttribute('aria-label', 'Elige el color junto a la foto');
      const caption = document.createElement('p'); caption.className = 'ad-photo-color-caption';
      const value = document.createElement('strong'); value.className = 'ad-photo-color-value';
      value.setAttribute('aria-live', 'polite'); value.setAttribute('aria-atomic', 'true');
      caption.append('Color: ', value);
      const swatches = document.createElement('div'); swatches.className = 'ad-photo-color-swatches';
      swatches.setAttribute('role', 'group'); swatches.setAttribute('aria-label', 'Colores disponibles');
      const next = document.createElement('button'); next.type = 'button'; next.className = 'ad-photo-color-next';
      next.textContent = 'Continuar personalización ↓';
      next.addEventListener('click', () => {
        const target = steps.find(step => step !== colorSource);
        if (!target) return;
        open(target, true); target.querySelector('.ad-choice-toggle')?.focus({ preventScroll: true });
      });
      panel.append(caption, swatches, next);
      // Thumbnails stay attached to the photo; the color choice goes right after them.
      const thumbs = gallery.parentElement?.querySelector(':scope > .productView-thumbnail-wrapper');
      (thumbs || gallery).after(panel);
      swatches.addEventListener('click', event => {
        const button = event.target.closest('.ad-photo-color');
        if (!button || button.disabled) return;
        const input = document.getElementById(button.dataset.input);
        const position = window.scrollY;
        const root = document.documentElement;
        const anchor = root.style.overflowAnchor;
        root.style.overflowAnchor = 'none';
        // Delegate to the original radio: variant, photo, price and properties stay native.
        input?.click(); schedule();
        // Slick rebuilds the gallery; keep the photo at the same viewport position.
        requestAnimationFrame(() => requestAnimationFrame(() => {
          const behavior = root.style.scrollBehavior;
          root.style.scrollBehavior = 'auto';
          window.scrollTo({ top: position, behavior: 'auto' });
          root.style.scrollBehavior = behavior;
          root.style.overflowAnchor = anchor;
        }));
      });
      swatches.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        const buttons = [...swatches.querySelectorAll('.ad-photo-color')].filter(button => !button.disabled && !button.hidden);
        const current = buttons.indexOf(event.target.closest('.ad-photo-color'));
        if (current < 0 || !buttons.length) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        buttons[index].focus({ preventScroll: true }); buttons[index].click();
      });
    }
    setText(panel.querySelector('.ad-photo-color-value'), selected(field));
    const swatches = panel.querySelector('.ad-photo-color-swatches');
    const used = new Set();
    field.querySelectorAll('input[type="radio"]').forEach(input => {
      const label = field.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (!label) return;
      used.add(input.id);
      let button = [...swatches.children].find(item => item.dataset.input === input.id);
      if (!button) {
        button = document.createElement('button'); button.type = 'button'; button.className = 'ad-photo-color';
        button.dataset.input = input.id; button.setAttribute('aria-label', input.value); button.title = input.value;
        const sample = document.createElement('span'); sample.className = 'ad-photo-color-sample'; sample.setAttribute('aria-hidden', 'true');
        button.append(sample); swatches.append(button);
      }
      const pattern = label.querySelector('.pattern');
      const sample = button.firstElementChild;
      const background = pattern?.style.backgroundImage || '';
      const color = pattern?.style.backgroundColor || '';
      if (sample.style.backgroundImage !== background) sample.style.backgroundImage = background;
      if (sample.style.backgroundColor !== color) sample.style.backgroundColor = color;
      button.disabled = input.disabled;
      button.hidden = label.style.display === 'none';
      const pressed = String(input.checked);
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
    });
    [...swatches.children].filter(button => !used.has(button.dataset.input)).forEach(button => button.remove());
    panel.querySelector('.ad-photo-color-next').hidden = !steps.some(step => step !== field);
  }
  function finishSelection(field) {
    if (!field?.classList.contains('ad-dropdown') || !field.classList.contains('is-open')) return;
    close(field);
    field.querySelector('.ad-choice-toggle').focus({ preventScroll: true });
  }
  page.addEventListener('change', event => {
    schedule();
    if (event.target.matches('input[type="radio"],select')) finishSelection(event.target.closest('.ad-choice'));
  });
  // TEPO only records a choice when its image is clicked. Our option rows are wider than
  // the image, so a tap on the name or padding checked the radio natively while TEPO kept
  // the field empty and blocked the purchase ("Some fields are required"). Route the whole
  // row to the image; clicks that already land on the image pass through untouched.
  page.addEventListener('click', event => {
    const row = event.target.closest('.tcustomizer-field label.tcustomizer__image-wrapper');
    if (!row || event.target.closest('.tcustomizer__image')) return;
    const image = row.querySelector('.tcustomizer__image');
    if (!image) return;
    event.preventDefault(); event.stopPropagation();
    image.click();
  }, true);
  // Clicking the already selected row also closes its selector.
  page.addEventListener('click', event => {
    const label = event.target.closest('label.product-form__label,label.tcustomizer__image-wrapper');
    if (!label) return;
    const input = label.htmlFor && document.getElementById(label.htmlFor);
    if (input?.type === 'radio' && input.checked) {
      requestAnimationFrame(() => finishSelection(label.closest('.ad-choice')));
    }
  });
  page.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const field = event.target.closest('.ad-choice.is-open');
    if (!field) return;
    event.preventDefault(); close(field);
    field.querySelector('.ad-choice-toggle').focus({ preventScroll: true });
  });
  page.addEventListener('input', schedule);
  page.addEventListener('focusin', event => {
    const field = event.target.closest('.ad-choice');
    if (field && event.target.matches('.tcustomizer-field__heading,input,textarea,select')) open(field);
  });
  document.addEventListener('ad:open-option', event => open(event.detail?.field));
  // React to native choices and app mounts, rather than our own preview updates
  // or unrelated descriptions and reviews elsewhere in the product block.
  const optionChanges = new MutationObserver(mutations => {
    const ownUi = '.ad-choice-toggle,.ad-photo-colors,.ad-personalize-intro,.ad-choice-next,.ad-swatch-name,.ad-summary';
    const nativeChoices = 'fieldset,.tcustomizer-field';
    const relevant = mutations.some(mutation => {
      const target = mutation.target.nodeType === Node.ELEMENT_NODE ? mutation.target : mutation.target.parentElement;
      if (target?.closest(ownUi)) return false;
      if (target?.closest(nativeChoices)) {
        if (mutation.type === 'characterData') return true;
        return [...mutation.addedNodes, ...mutation.removedNodes].some(node =>
          node.nodeType === Node.TEXT_NODE || (node.nodeType === Node.ELEMENT_NODE &&
          !node.matches('.ad-wood-sample,' + ownUi))
        );
      }
      return [...mutation.addedNodes].some(node => node.nodeType === Node.ELEMENT_NODE &&
        (node.matches(nativeChoices) || node.querySelector(nativeChoices)));
    });
    if (relevant) schedule();
  });
  optionChanges.observe(page, { childList: true, subtree: true, characterData: true });
  init();
})();
